import { orderHasExpertAudit } from "@/lib/expert-line-items";
import { userOwnsCustomerOrder } from "@/lib/order-access";
import { createSupabaseBrowserClient } from "@/lib/supabase/client";

export async function getExpertAudioPlaybackUrl(orderId: string): Promise<string | null> {
  const sb = createSupabaseBrowserClient();
  const {
    data: { user },
  } = await sb.auth.getUser();
  if (!user) return null;

  const { data: order, error: oErr } = await sb
    .from("customer_orders")
    .select("id, user_id, customer_email, line_items")
    .eq("id", orderId)
    .maybeSingle();
  if (oErr || !order || !userOwnsCustomerOrder(user, order) || !orderHasExpertAudit(order.line_items)) return null;

  const { data: expert } = await sb
    .from("expert_audio_reviews")
    .select("audio_storage_path, status")
    .eq("customer_order_id", orderId)
    .maybeSingle();
  if (!expert?.audio_storage_path) return null;
  if (expert.status !== "audio_submitted" && expert.status !== "writeup_ready") return null;

  const { data: signed, error: sErr } = await sb.storage.from("expert-audio").createSignedUrl(expert.audio_storage_path, 3600);
  if (sErr || !signed?.signedUrl) return null;
  return signed.signedUrl;
}

export async function getExpertWriteupPdfUrl(orderId: string): Promise<string | null> {
  const sb = createSupabaseBrowserClient();
  const {
    data: { user },
  } = await sb.auth.getUser();
  if (!user) return null;

  const { data: order, error: oErr } = await sb
    .from("customer_orders")
    .select("id, user_id, customer_email, line_items")
    .eq("id", orderId)
    .maybeSingle();
  if (oErr || !order || !userOwnsCustomerOrder(user, order) || !orderHasExpertAudit(order.line_items)) return null;

  const { data: expert } = await sb
    .from("expert_audio_reviews")
    .select("writeup_pdf_path, status")
    .eq("customer_order_id", orderId)
    .maybeSingle();
  if (!expert?.writeup_pdf_path || expert.status !== "writeup_ready") return null;

  const { data: signed, error: sErr } = await sb.storage.from("expert-writeups").createSignedUrl(expert.writeup_pdf_path, 3600);
  if (sErr || !signed?.signedUrl) return null;
  return signed.signedUrl;
}
